var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"c-button",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }